import { render, staticRenderFns } from "./CreateHousing.vue?vue&type=template&id=25584ce0&scoped=true&"
import script from "./CreateHousing.vue?vue&type=script&lang=js&"
export * from "./CreateHousing.vue?vue&type=script&lang=js&"
import style0 from "./CreateHousing.vue?vue&type=style&index=0&id=25584ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25584ce0",
  null
  
)

export default component.exports